import { useEffect, useState } from "react";
import DivStyle from "../../components/style/div.component";
import Page from "../../components/table/paging";
import { FormProps } from "../../components/form/interface/formInterface";
import InputFormStyle from "../../components/style/input_form.component";
import Icon from "@mdi/react";
import { mdiMagnify } from "@mdi/js";
import SmallForm from "../../components/form/small_form";
import AdTable from "../../components/table/AdTable";
import { TournamentAdVIdeoDto } from "./interface/interface";
import AdminAPI from "../../api/admin";
import ButtonStyle from "../../components/style/button.component";

const TournamentAdVideo = () => {
  const [list, setList] = useState<TournamentAdVIdeoDto[]>([]);
  const [searchList, setSearchList] = useState<TournamentAdVIdeoDto[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [mode, setMode] = useState("V");

  const [id, setId] = useState(0);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [order, setOrder] = useState(0);
  const [isHidden, setIsHidden] = useState(false);
  const [isCompanyHidden, setIsCompanyHidden] = useState(false);

  const [selectedFile, setSelectedFile] = useState(null);

  const formData: FormProps = {
    title: "상세정보",
    form: [
      {
        value: title,
        setValue: setTitle,
        label: "광고 영상 제목",
        type: "input",
        width: "100%",
      },
      {
        value: order,
        setValue: setOrder,
        label: "광고 영상 순서",
        type: "input",
        width: "100%",
      },
      {
        value: isHidden,
        setValue: setIsHidden,
        label: "숨김 여부",
        type: "check",
        width: "100%",
      },
      {
        value: isCompanyHidden,
        setValue: setIsCompanyHidden,
        label: "본사 숨김 여부",
        type: "check",
        width: "100%",
      },
      {
        value: selectedFile,
        setValue: setSelectedFile,
        label: "광고 영상을 첨부해주세요.",
        type: "file-video",
        width: "100%",
      },
      {
        value: description,
        setValue: setDescription,
        label: "광고 영상 설명",
        type: "text",
        width: "100%",
      },
    ],
  };

  const headers = [
    {
      text: "순번",
      align: "center",
      sortable: false,
      value: "order",
    },
    {
      text: "광고 영상 제목",
      align: "start",
      sortable: false,
      value: "title",
    },
    {
      text: "URL",
      align: "start",
      sortable: false,
      value: "videoUrl",
      width: "400px",
    },
    {
      text: "노출 여부",
      align: "center",
      value: "isHidden",
    },
    {
      text: "본사 노출 여부",
      align: "center",
      value: "isCompanyHidden",
    },
  ];

  const setDetail = async (item: TournamentAdVIdeoDto) => {
    setMode("U");
    setId(item.id);
    setTitle(item.title);
    setDescription(item.description);
    setOrder(item.order);
    setIsHidden(item.isHidden);
    setIsCompanyHidden(item.isCompanyHidden);
  };
  const addForm = () => {
    setMode("I");
    setId(0);
    setTitle("");
    setDescription("");
    setOrder(0);
  };
  const save = async () => {
    const body = {
      title,
      description,
      order,
      isHidden,
    };
    let formData = null;
    formData = new FormData();
    if (selectedFile) {
      formData.append("file", selectedFile);
    }
    formData.append("title", title);
    formData.append("description", description);
    formData.append("order", order.toString());
    formData.append("isHidden", isHidden.toString());
    formData.append("isCompanyHidden", isCompanyHidden.toString());

    if (window.confirm("저장 하시겠습니까?")) {
      try {
        await AdminAPI.updateVideo(id, formData);
        alert("저장되었습니다.");
        addForm();
        getAdvertisement();
      } catch (e: any) {
        alert(e.message);
      }
    }
  };

  const remove = async () => {
    if (window.confirm("삭제 하시겠습니까?")) {
      try {
        await AdminAPI.deleteVideo(id);
        alert("삭제 되었습니다.");
        getAdvertisement();
        addForm();
      } catch (e: any) {
        alert(e.message);
      }
    }
  };
  const add = async () => {
    if (selectedFile) {
      let formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("title", title);
      formData.append("description", description);
      formData.append("order", (list.length + 1).toString());
      formData.append("isHidden", isHidden.toString());
      formData.append("isCompanyHidden", isCompanyHidden.toString());
      if (window.confirm("신규 등록 하시겠습니까?")) {
        try {
          await AdminAPI.registerVideo(formData);
          alert("신규 등록이 되었습니다.");
          getAdvertisement();
          addForm();
        } catch (e: any) {
          alert(e.message);
        }
      }
    } else {
      alert("영상을 선택해주세요.");
    }
  };
  const handleSearch = (search: string) => {
    setCurrentPage(1); // 검색 후 첫 페이지로 이동

    if (!search.trim()) {
      setSearchList(list); // 검색어가 비어있다면 전체 목록을 다시 보여줌
      const totalPages = Math.ceil(list.length / 10); // 페이지 총 개수 계산
      setTotalPages(totalPages);
      return;
    }

    const filteredList = list.filter((user: TournamentAdVIdeoDto) => {
      // 모든 객체의 키를 반복하여 해당 키의 값에 검색어가 포함되어 있는지 확인
      return Object.values(user).some((value) => {
        if (value)
          return value.toString().toLowerCase().includes(search.toLowerCase());
      });
    });

    setSearchList(filteredList); // 필터링된 리스트를 검색 결과로 설정
    const totalPages = Math.ceil(filteredList.length / 10); // 페이지 총 개수 계산
    setTotalPages(totalPages);
  };

  const getAdvertisement = async () => {
    const res = await AdminAPI.getVideoList();
    if (res && res.status === 200) {
      const totalPages = Math.ceil(res.data.length / 10);
      setTotalPages(totalPages);

      setList(res.data);
      setSearchList(res.data);
    }
  };
  useEffect(() => {
    getAdvertisement();
  }, []);
  return (
    <DivStyle
      style={{ overflow: "auto" }}
      backgroundColor="#121212"
      height="100vh"
      display="flex"
      flex_direction="row"
      marginTop="65px"
      setMobile={true}
    >
      <DivStyle
        width="66%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="flex-end"
      >
        <DivStyle
          width="100%"
          height="auto"
          display="flex"
          flex_direction="column"
          align_items="center"
          setMobileTable={true}
        >
          <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>
            광고 관리
          </h2>
          <DivStyle
            width="95%"
            display="flex"
            backgroundColor="#1E1E1E"
            flex_direction="column"
            borderRadius="10px"
            marginTop="30px"
            marginBottom="20px"
          >
            <DivStyle
              width="100%"
              display="flex"
              flex_direction="row"
              justify_content="space-between"
              align_items="center"
            >
              <DivStyle
                width="100%"
                display="flex"
                flex_direction="row"
                justify_content="end"
                align_items="center"
              >
                <DivStyle
                  width="50%"
                  display="flex"
                  justify_content="flex-end"
                  flex_direction="row"
                  align_items="center"
                  marginRight="20px"
                  marginTop="20px"
                >
                  <InputFormStyle
                    onChange={(e) => handleSearch(e.target.value)}
                  ></InputFormStyle>
                  <Icon path={mdiMagnify} size={1} style={{ color: "white" }} />
                </DivStyle>
              </DivStyle>
            </DivStyle>

            <AdTable
              headers={headers}
              currentPage={currentPage}
              dataList={searchList}
              setDetail={setDetail}
              setDataList={setSearchList}
            />
            <Page
              currentPage={currentPage}
              totalPages={totalPages}
              dataList={searchList}
              setCurrentPage={setCurrentPage}
            />
          </DivStyle>
        </DivStyle>
        <ButtonStyle
          border="none"
          backgroundColor="#1976D2"
          width="85px"
          height="40px"
          color="white"
          borderRadius="5px"
          marginRight="25px"
          onClick={() => addForm()}
        >
          신규 등록
        </ButtonStyle>
      </DivStyle>
      <DivStyle
        width="33%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileForm={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>폼</h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <SmallForm
            form={formData.form}
            title={formData.title}
            save={save}
            add={add}
            mode={mode}
            remove={remove}
          />
        </DivStyle>
      </DivStyle>
    </DivStyle>
  );
};

export default TournamentAdVideo;
